export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/TL-0ee9a45b4a50f1ead843f6d85a49c2f9.png";